export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-social-linkedin-7cd15a1dc33fef9501d8ac0351d90c0e.svg";